import { useEffect, useState } from 'react'

function readLayout() {
  const wide = window.matchMedia('(min-width: 768px)').matches
  const roomy = window.matchMedia('(min-width: 1000px)').matches
  return { wide, roomy }
}

/**
 * The only width-driven decision in the app. A narrow Mac window deliberately
 * uses the iOS shell, while a macOS sidebar auto-collapses below 1000px.
 */
export function useLayout() {
  const [state, setState] = useState(readLayout)

  useEffect(() => {
    const wideMq = window.matchMedia('(min-width: 768px)')
    const roomyMq = window.matchMedia('(min-width: 1000px)')
    const onChange = () => setState({ wide: wideMq.matches, roomy: roomyMq.matches })
    wideMq.addEventListener('change', onChange)
    roomyMq.addEventListener('change', onChange)
    return () => {
      wideMq.removeEventListener('change', onChange)
      roomyMq.removeEventListener('change', onChange)
    }
  }, [])

  return {
    platform: state.wide ? 'mac' : 'ios',
    sidebarAutoCollapsed: state.wide && !state.roomy,
  }
}
